'use client';

import {
  type PresentingLocale,
  resolveTranslations,
} from '@mentimeter/i18n-core';
import { usePrevious } from '@mentimeter/react-hooks';
import { NextIntlClientProvider } from 'next-intl';
import React, { useEffect } from 'react';
import { getPresentingLocale } from '../getPresentingLocale';
import { messages as presentingMessages } from '../messages';

interface PropsT {
  children: React.ReactNode;
  language?: string;
}

export const NextIntlPresentingProvider = ({ children, language }: PropsT) => {
  const presentingLocale = getPresentingLocale(language);

  const [messages, setMessages] = React.useState(() =>
    resolveTranslations<PresentingLocale>(presentingLocale, presentingMessages),
  );

  const previousLocale = usePrevious<PresentingLocale, PresentingLocale>(
    presentingLocale,
    presentingLocale,
  );

  // Make sure resolveTranslations is only called when the locale changes
  useEffect(() => {
    if (previousLocale === presentingLocale) {
      return;
    }

    setMessages(
      resolveTranslations<PresentingLocale>(
        presentingLocale,
        presentingMessages,
      ),
    );
  }, [presentingLocale, previousLocale]);

  return (
    <NextIntlClientProvider messages={messages} locale={presentingLocale}>
      {children}
    </NextIntlClientProvider>
  );
};
